<template>
  <BreadCrumb PageTitle="Bons Suivi livreur" />
  <ListNotes />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import ListNotes from "@/components/Notes/Pointage/ListNote.vue";

export default defineComponent({
  name: "ListNotesPage",
  components: {
    BreadCrumb,
    ListNotes,
  },
});
</script>